"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vatRules = _interopRequireDefault(require("./vatRules"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const checkVatRules = (country, type) => {
  const rule = _vatRules.default === null || _vatRules.default === void 0 ? void 0 : _vatRules.default.find(_ref => {
    let {
      countryCode
    } = _ref;
    return countryCode === country;
  });
  if (!rule) return false;
  const {
    types = []
  } = rule || {};
  return types.indexOf(type) > -1;
};
var _default = exports.default = checkVatRules;